{
  "zh-CN": {
    "number": {
      "format": {
        "precision": 2,
        "strip_insignificant_zeros": true,
        "delimiter": ".",
        "separator": ","
      },
      "units": {
        "au": "AU",
        "uec": "aUEC",
        "currency": "$",
        "uecPerUnit": "aUEC / Unit",
        "distance": "m",
        "weight": "t",
        "speed": "m/s",
        "cargo": "SCU",
        "person": "人",
        "people": {
          "one": "人",
          "other": "人"
        }
      },
      "uec": "%{count} <span class=\"text-muted\">aUEC</span>",
      "uecPerUnit": "%{count} <span class=\"text-muted\">aUEC/unit</span>",
      "percent": "%{count} %",
      "distance": "%{count} m",
      "newton": "%{count} KN",
      "weight": "%{count} t",
      "speed": "%{count} m/s",
      "seconds": "%{count} s",
      "rateOfFire": "%{count} shots/min",
      "rotation": "%{count} deg/s",
      "cargo": "%{count} SCU",
      "fuel": "%{count}",
      "ships": {
        "one": "%{count} 飞船",
        "other": "%{count} 飞船"
      },
      "people": {
        "one": "%{count} 人",
        "other": "%{count} 人"
      }
    }
  }
}
